/********************************************************************************************
*****                                                                                   *****
*****    IMPORTANT! Changes here must also be set in /src/styles/common/_colors.scss    *****
*****                                                                                   *****
/*******************************************************************************************/


// Colors

export const ERROR_RED = '#E50303';
export const DD_PURPLE = '#591f69';
export const LAVENDAR = '#4B2D53';
export const WHITE = '#FFFFFF';